import { CSSObject } from '@chakra-ui/react';
import { CustomButtonProps } from '@/components/Button/Button';

export const InputContainer: CSSObject = {
  '& .chakra-checkbox__label': {
    color: 'white',
  },
  '& .chakra-form__label': {
    color: 'white',
  },
  '#period-select': {
    border: 'none',
    color: 'white',
    bg: 'blackAlpha.500',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.15) inset',
  },
  '& .chakra-select__icon-wrapper': {
    color: 'beta.500',
  },
};
export const buttonConfirmBreakProps: CustomButtonProps = {
  height: '38px',
  pt: '0.5',
  variant: 'secondary',
  sx: {
    span: {
      color: 'blackAlpha.800',
    },
  },
};
export const TextConfirmBreak: CSSObject = {
  fontSize: 'xs',
  color: 'white',
};
export const TextDate: CSSObject = {
  fontSize: 'md',
  color: 'gamma.300',
};
export const TextDateLabel: CSSObject = {
  fontSize: 'xs',
  fontFamily: 'roboto',
};
export const BoxTakeABreak: CSSObject = {
  p: '0',
  m: '0',
};
export const buttonTakeBreakProps: CustomButtonProps = {
  height: '38px',
  pt: '1',
  variant: 'secondary',
  lineHeight: 'normal',
  fontWeight: 'bold',
};
export const ListItemExclusionItem: CSSObject = {
  fontSize: 'xs',
  color: 'white',
};
export const HeadingInformation: CSSObject = {
  fontWeight: 'medium',
  mb: '0',
  fontSize: 'sm',
  color: 'white',
};
export const TextInformation: CSSObject = {
  fontSize: 'xs',
  mb: '3',
  color: 'white',
  '&:first-of-type': {
    fontWeight: 'bold',
  },
};
export const BoxStyledLink: CSSObject = {
  color: 'beta.500',
};
export const TextM: CSSObject = {
  fontSize: 'sm',
  color: 'white',
  fontWeight: 'medium',
  mb: '0',
};
export const BoxTakeABreakWrapper: CSSObject = {
  pb: 0,
  border: 'none',
};
export const TakeABreakContainer: CSSObject = {
  color: 'white',
  p: '0',
  b: '0',
  mb: '3',
  fontSize: 'xs',
  strong: {
    fontSize: 'sm',
  },
};
export const TextS: CSSObject = {
  color: 'white',
  pt: '2',
  m: '0',
  fontSize: '12px',
  pb: '1',
};
